import { render, staticRenderFns } from "./BookDetailPage.vue?vue&type=template&id=0f830c6c&"
import script from "./BookDetailPage.vue?vue&type=script&lang=js&"
export * from "./BookDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./BookDetailPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports